import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SideCard } from 'components/cards/cmpSideCard';
import JobList from 'components/jobs/list';
import { scrollTo } from 'utils';

import { formatNumber } from '../../../utils';

import Styles from './index.module.css';

const Sidebar = ({
  genderRatio,
  genderOverTime,
  averageAge,
  jobTitle,
  jobListDismiss,
  locations,
  origin,
  jobsIndex,
  ethnicities,
  topIndustry,
  className,
  averageSalary,
  jobTitlePlural,
}) => {
  const formatGenderRatioPercentage = (ratio) => {
    return (ratio * 100).toFixed(0);
  };

  const generateGenderRatioText = () => {
    return `Male - ${formatGenderRatioPercentage(genderRatio.male)}%
        Female - ${formatGenderRatioPercentage(genderRatio.female)}%`;
  };

  const generateRaceText = () => {
    return ethnicities.map((eth) => `${eth.name} - ${eth.percent}%`).join('\n');
  };

  const scrollToWithOffset = (id) => {
    scrollTo(id, 1800, false);
  };

  const isGenderRatioExists = genderRatio && genderRatio.male && genderRatio.female;

  const createFooterLink = (link, url) => {
    return <div className="z-link font-weight-600 z-mt-4">{link}</div>;
  };

  const data = [];
  if (isGenderRatioExists)
    data.push({
      title: 'Gender Ratio',
      value: generateGenderRatioText(),
      onClick: () => scrollToWithOffset('gender-statistics'),
      isDisabled: !genderOverTime?.length,
      footer: createFooterLink('See All Gender Info'),
    });
  if (ethnicities?.length)
    data.push({
      title: `Percentage of ${jobTitlePlural} By Race`,
      value: generateRaceText(),
      onClick: () => scrollToWithOffset('race-statistics'),
      footer: createFooterLink('See All Race Info'),
    });
  if (averageAge)
    data.push({
      title: 'Average Age',
      value: averageAge.toFixed(1),
      onClick: () => scrollToWithOffset('age-by-ethinicty-gender'),
      footer: createFooterLink('See All Age Info'),
    });
  if (topIndustry)
    data.push({
      title: `Top Industry`,
      value: topIndustry.industrie,
      footer: createFooterLink('See Employment Statistics'),
      onClick: () => scrollToWithOffset('employment-statistics-section'),
    });
  if (averageSalary)
    data.push({
      title: `${jobTitlePlural} Average Salary`,
      value: '$' + formatNumber(averageSalary),
      footer: createFooterLink('See All Heatmaps'),
      onClick: () => scrollToWithOffset('heatmaps-section'),
    });

  const cardAttributes = (link, onClick) => {
    const attributes = {};
    if (link) {
      attributes.link = link;
    } else {
      attributes.onClick = onClick;
    }
    return attributes;
  };

  return (
    <aside className={classNames('side-with-jobs', className || '', Styles.aside)}>
      {data.map(({ title, value, link, isDisabled, onClick, noShadow, footer }, index) => (
        <SideCard
          key={title + index}
          title={title}
          value={value}
          isDisabled={isDisabled}
          noShadow={noShadow}
          footer={footer}
          {...cardAttributes(link, onClick)}
        />
      ))}
      {!jobListDismiss && (
        <div className="job-list-placeholder d-none d-lg-flex">
          <JobList
            title={`${jobTitle} Jobs You Might Like`}
            jobsPageIndexable={jobsIndex}
            origin={origin}
            initialPayload={{
              title: jobTitle,
              locations,
            }}
            usingPaidAPI={true} // It will use paid job API everytime
          />
        </div>
      )}
    </aside>
  );
};

Sidebar.propTypes = {
  genderRatio: PropTypes.objectOf(PropTypes.number, PropTypes.number),
  averageAge: PropTypes.number,
  jobsCount: PropTypes.number,
  jobTitlePlural: PropTypes.string,
};

export default Sidebar;
